<p-toast #toast>
  <ng-template let-message pTemplate="message">
    @if (!message.icon) {
      <span class="p-toast-message-icon">
        @if (message.severity === 'success') {
          <i class="icon-check ic-success"></i>
        }
        @if (message.severity === 'info') {
          <i class="icon-info ic-primary d-block"></i>
        }
        @if (message.severity === 'error') {
          <i class="icon-close ic-error d-block"></i>
        }
        @if (message.severity === 'warn') {
          <i class="icon-warning ic-warning d-block"></i>
        }
      </span>
    }
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" [innerHTML]="message.detail | safeHtml"></div>
      <!-- @Todo Implement CTA button logic (TT-2239)-->
      <!--<button *ngIf="message.data.onCTAClick" class="primary compact p-5 mt-10 h-auto">-->
      <!--  See details-->
    <!--</button>-->
  </div>
  <button class="btn icon-close ic-text"
    (click)="onClose(message)">
  </button>
</ng-template>
</p-toast>
